import axios from "axios";
import { SERVER_API_URL } from '@/constants';

export default class ActivateService {

  public activateAccount(key: string): Promise<any> {
    return axios.get(`api/public/activate?key=${key}`);
  }
}
